<template>
  <div>
    <div class="table-contract-container">
      <el-row>
        <el-col :span="6" class="filter-input">
          <el-input
            :placeholder="$t('keyword')"
            @input="isSearching = true"
            v-model="keyword"></el-input>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-loading="isSearching">
        <el-col :span="24">
          <div class="contract-table">
            <ul class="contract-table-head">
              <li style="width: 5%"></li>
              <li style="width: 15%; vertical-align: middle;">{{$t('code')}}</li>
              <li style="width: 35%; vertical-align: middle;">{{$t('name')}}</li>
              <li style="width: 10%; vertical-align: middle; text-align: center;"
                  v-html="$t('includeBreakfast')"></li>
              <li style="width: 10%; vertical-align: middle; text-align: center;">{{$t('period')}}</li>
              <li style="width: 10%; vertical-align: middle; text-align: center;">{{$t('room')}}</li>
              <li style="width: 15%; vertical-align: middle; text-align: center;"></li>
            </ul>
          </div>
          <div v-for="(rateCode, index) of rateCodeDataList" :key="`rate-code-${index}`">
            <div class="contract-table" v-show="rateCode.isShow">
              <ul>
                <li style="width: 5%; text-align: center">
                  <el-checkbox v-model="rateCodeCheckList[index].isCheck" @change="onSelectRateCodeChange"></el-checkbox>
                </li>
                <li style="width: 15%">{{rateCode.code}}</li>
                <li style="width: 35%">{{rateCode.name}}</li>
                <li style="width: 10%; text-align: center;">{{bindIncludeBreakfast(rateCode.includeBreakfast)}}</li>
                <li style="width: 10%; text-align: center;">
                <span v-if="isDisplayViewRateButton(rateCode)">
                  {{ rateCode.totalPeriod }}
                </span>
                </li>
                <li style="width: 10%; text-align: center;">
                <span v-if="isDisplayViewRateButton(rateCode)">
                  {{ rateCode.totalRoom }}
                </span>
                </li>
                <li style="width: 15%; text-align: center;">
                  <view-rate-detail-button
                    v-if="isDisplayViewRateButton(rateCode)"
                    :rate-code="rateCode"
                    :rate-code-detail-list="rateCode.rateDetail"
                    :room-type-list="roomTypeList"
                    @onGetDetailError="onGetDetailError">
                  </view-rate-detail-button>
                </li>
              </ul>
              <div class="contract-data-version" v-if="isUpdatedData(rateCodeList, rateCode)">
                <div class="contract-data-updated">
                  <div style="padding: 20px 0 0 20px">
                    <strong>*{{$t('updatedRateCodeMessage')}}</strong>
                  </div>
                  <el-radio-group v-model="rateCodeCheckList[index].version" fill="#ff0000" @change="onSelectRateCodeChange()">
                    <div>
                      <ul style="padding-left: 0;">
                        <li style="width: 55%; padding-left: 40px">
                          <div class="contract-data-version-radio">
                            <el-radio :label="DATA_VERSION.SELECTED">{{$t('selectedVersion')}} ({{bindUpdatedAt(rateCode.updatedAt)}})</el-radio>
                          </div>
                        </li>
                        <li style="width: 10%; text-align: center;">{{ bindIncludeBreakfast(rateCode.includeBreakfast) }}</li>
                        <li style="width: 10%; text-align: center;">{{ rateCode.totalPeriod }}</li>
                        <li style="width: 10%; text-align: center;">{{ rateCode.totalRoom }}</li>
                        <li style="width: 15%; text-align: center;">
                          <view-rate-detail-button
                            :rate-code="rateCode"
                            :rate-code-detail-list="getSelectedRateCodeDetailList(rateCode.id)"
                            :room-type-list="roomTypeList"
                            @onGetDetailError="onGetDetailError">
                          </view-rate-detail-button>
                        </li>
                      </ul>
                      <ul style="padding-left: 0;">
                        <li style="width: 55%; padding-left: 40px">
                          <div class="contract-data-version-radio">
                            <el-radio :label="DATA_VERSION.LATEST">{{$t('latestVersion')}} ({{bindLatestUpdatedAt(rateCode.id)}})</el-radio>
                          </div>
                        </li>
                        <li style="width: 10%; text-align: center;">{{ bindIncludeBreakfast(rateCodeListById[rateCode.id].includeBreakfast) }}</li>
                        <li style="width: 10%; text-align: center;">{{ rateCodeListById[rateCode.id].totalPeriod }}</li>
                        <li style="width: 10%; text-align: center;">{{ rateCodeListById[rateCode.id].totalRoom }}</li>
                        <li style="width: 15%; text-align: center;">
                          <view-rate-detail-button
                            :rate-code="rateCodeListById[rateCode.id]"
                            :rate-code-detail-list="rateCodeListById[rateCode.id].rateDetail"
                            :room-type-list="roomTypeList"
                            @onGetDetailError="onGetDetailError">
                          </view-rate-detail-button>
                        </li>
                      </ul>
                    </div>
                  </el-radio-group>
                </div>
              </div>
              <div class="contract-data-version" v-if="isDeletedData(rateCodeList, rateCode.id)">
                <div class="contract-data-deleted">
                  <div style="padding: 20px 0 0 20px">
                    <strong style="color: #dd3333">*{{$t('deletedRateCodeMessage')}}</strong>
                  </div>
                  <el-radio-group v-model="rateCode.id" fill="#ff0000" >
                    <div>
                      <ul style="padding-left: 0;">
                        <li style="width: 60%; padding-left: 40px">
                          <div class="contract-data-version-radio">
                            <el-radio :label="rateCode.id">{{$t('selectedVersion')}} ({{bindUpdatedAt(rateCode.updatedAt)}})</el-radio>
                          </div>
                        </li>
                        <li style="width: 10%; text-align: center;">{{ rateCode.totalPeriod }}</li>
                        <li style="width: 10%; text-align: center;">{{ rateCode.totalRoom }}</li>
                        <li style="width: 20%; text-align: center;">
                          <view-rate-detail-button
                            :rate-code="rateCode"
                            :rate-code-detail-list="getSelectedRateCodeDetailList(rateCode.id)"
                            :room-type-list="roomTypeList"
                            @onGetDetailError="onGetDetailError">
                          </view-rate-detail-button>
                        </li>
                      </ul>
                    </div>
                  </el-radio-group>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <remark-component
      :remark-type="REMARK_TYPE.RATE_CODE"
      :remark-list="defaultRemarkList"
      :contract-detail="contractDetail"
      @onRemarkChange="onRemarkChange">
    </remark-component>
  </div>
</template>

<script>
import { STATUS, REMARK_TYPE } from '@/configs/constant'
import { get, debounce } from 'lodash'
import i18nMessages from '@/translations/Contract/components/TabContractRateCode.i18n'
import ViewRateDetailButton from '@/components/Button/ViewRateDetailButton'
import { filterDataByKeyword } from '@/services/general-service'
import { getTableDataSource } from '@/services/contract-service'
import RemarkComponent from '@/views/Contract/components/RemarkComponent'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import { applyNewRemark } from '@/domains/contract-domain'
import { dateFormat } from '@/helpers/datetime'
import {
  isUpdatedData,
  isDeletedData,
  DATA_VERSION,
  getSelectedDataListByVersion,
  getDataCheckList
} from '@/services/version-service'

export default {
  name: 'TabRateCodeComponent',
  mixins: [AlertViewMixin],
  components: { ViewRateDetailButton, RemarkComponent },
  i18n: { messages: i18nMessages },
  model: {
    prop: 'contractDetail',
    event: 'onRateCodeListChange'
  },
  props: {
    contractDetail: {
      type: Object,
      default: function () {
        return {}
      }
    },
    roomTypeList: {
      type: Array,
      default: () => {
        return []
      }
    },
    rateCodeList: {
      type: Array,
      default: () => {
        return []
      }
    },
    defaultRemarkList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  watch: {
    keyword: debounce(function () {
      this.isSearching = false
    }, 300),
    isSearching: function (value) {
      if (!value) {
        this._filterRateCodeListDataSource()
      }
    }
  },
  created: function () {
    this._initRateCodeList()
    const rateCodeList = get(this.contractDetail, 'rateCodeList', [])
    this.rateCodeCheckList = getDataCheckList(this.rateCodeDataList, rateCodeList)
    this.tempContractRateCodeList = [ ...rateCodeList ]
  },
  data () {
    return {
      isUpdatedData,
      isDeletedData,
      DATA_VERSION,
      rateCodeDataList: [],
      rateCodeListById: {},
      tempContractRateCodeList: [],
      rateCodeCheckList: [],
      newRemark: {},
      keyword: '',
      isSearching: false,
      REMARK_TYPE
    }
  },
  methods: {
    _initRateCodeList: function () {
      const rateCodeList = get(this.contractDetail, 'rateCodeList', [])
      this.rateCodeDataList = getTableDataSource(this.rateCodeList, rateCodeList)
      this.rateCodeDataList.sort((prev, next) => (prev.code > next.code) ? 1 : -1)

      this.rateCodeList.forEach((rateCode) => {
        this.rateCodeListById[rateCode.id] = rateCode
      })

      this._prepareFilter()
    },
    _prepareFilter: function () {
      this.rateCodeDataList = this.rateCodeDataList.map((rateCode) => {
        rateCode.isShow = true
        return rateCode
      })
    },
    _filterRateCodeListDataSource: function () {
      const searchKeys = ['code', 'name']
      const filteredRateCodeDataList = filterDataByKeyword(this.rateCodeDataList, this.keyword, searchKeys)

      this.rateCodeDataList = this.rateCodeDataList.map((rateCode) => {
        const filteredRateCode = filteredRateCodeDataList.find(item => item.id === rateCode.id)
        rateCode.isShow = (filteredRateCode !== undefined)

        return rateCode
      })
    },
    onSelectRateCodeChange: function () {
      const remarkList = applyNewRemark(this.contractDetail, this.newRemark)

      const result = getSelectedDataListByVersion(
        this.rateCodeCheckList,
        this.rateCodeDataList,
        this.rateCodeList
      )
      const newRateCodeList = {
        rateCodeList: result
      }

      const newRemarkList = {
        remarkList: remarkList
      }

      const contractDetail = Object.assign({}, this.contractDetail, newRateCodeList, newRemarkList)
      this.$emit('onRateCodeListChange', contractDetail)
    },
    onRemarkChange: function (newRemark) {
      this.newRemark = newRemark

      this.onSelectRateCodeChange()
    },
    getSelectedRateCodeDetailList: function (rateCodeId) {
      const selectedRateCode = this.tempContractRateCodeList.find(item => item.id === rateCodeId)
      const rateDetailList = get(selectedRateCode, 'rateDetail', [])

      return rateDetailList
    },
    isDisplayViewRateButton: function (rateCode) {
      const isUpdated = isUpdatedData(this.rateCodeList, rateCode)
      const isDeleted = isDeletedData(this.rateCodeList, rateCode.id)
      const isDisplayViewRateButton = (!isUpdated && !isDeleted)

      return isDisplayViewRateButton
    },
    bindLatestUpdatedAt: function (rateCodeId) {
      const rateCode = this.rateCodeList.find(item => item.id === rateCodeId)

      if (rateCode !== undefined) {
        const date = new Date(rateCode.updatedAt)
        return dateFormat.long(date)
      }
    },
    bindUpdatedAt: function (updatedDate) {
      const date = new Date(updatedDate)
      return dateFormat.long(date)
    },
    bindIncludeBreakfast: function (status) {
      if (status === STATUS.ENABLE) {
        return this.$t('yes')
      }

      return this.$t('no')
    },
    onGetDetailError: function (err) {
      this.alertError(err.message)
    }
  }
}
</script>

<style scoped>
  .filter-input {
    left: 5%;
    position: relative;
    padding: 10px 0;
  }

  .table-contract-container {
    margin: 0 30px;
    box-shadow: #d4d4d4 0 0 5px;
    border: 1px solid #dddddd;
    border-radius: 5px;
  }
</style>
